import { render, staticRenderFns } from "./dangerMasterPop.vue?vue&type=template&id=1f9b2cb4"
import script from "./dangerMasterPop.vue?vue&type=script&lang=js"
export * from "./dangerMasterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9b2cb4')) {
      api.createRecord('1f9b2cb4', component.options)
    } else {
      api.reload('1f9b2cb4', component.options)
    }
    module.hot.accept("./dangerMasterPop.vue?vue&type=template&id=1f9b2cb4", function () {
      api.rerender('1f9b2cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerMasterPop.vue"
export default component.exports